import { buildCalendarPath } from "../pages/calendar/build-calendar-path";
import {
  useShallowCalendarStore,
  useShallowContactsDefaultViewStore,
  useShallowVitalsDefaultViewStore,
  useTicketsDefaultViewShallowStore,
} from "../store";
import { resolveRoutePath } from "./resolve-route-path";

/**
 * Resolves a navbar-facing route path to its final leaf destination so
 * clicking the navbar item navigates directly there (no intermediate
 * `<Navigate>` redirect commit). Handles static `indexRedirect` chains via
 * `resolveRoutePath` and dynamic redirects (calendar/contacts/tickets/vitals)
 * inline by reading persisted store state.
 */
export const useResolveRoutePath = (path: string): string => {
  const { lastSelectedViewType, lastSelectedViewId: lastSelectedCalendarViewId } = useShallowCalendarStore(
    "lastSelectedViewType",
    "lastSelectedViewId"
  );
  const { lastSelectedViewId: lastSelectedContactsViewId } = useShallowContactsDefaultViewStore("lastSelectedViewId");
  const { lastSelectedViewId: lastSelectedTicketsViewId } = useTicketsDefaultViewShallowStore("lastSelectedViewId");
  const { lastSelectedViewId: lastSelectedVitalsViewId } = useShallowVitalsDefaultViewStore("lastSelectedViewId");

  if (path === "/calendar") {
    return buildCalendarPath({
      viewType: lastSelectedViewType,
      fallbackViewType: lastSelectedViewType,
      fallbackViewId: lastSelectedCalendarViewId,
      date: "today",
    });
  }

  if (path === "/contacts") {
    return `/contacts/views/${lastSelectedContactsViewId}`;
  }

  if (path === "/tickets") {
    return `/tickets/views/${lastSelectedTicketsViewId}`;
  }

  if (path === "/vitals") {
    return `/vitals/views/${lastSelectedVitalsViewId}`;
  }

  return resolveRoutePath(path);
};
